import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getDeliveryOptions from 'store/product/selector/getDeliveryOptions';

import cn from 'classnames';
import styles from './DeliveryOptions.module.scss';
import Accordion from '../../Common/Accordion/Accordion';

interface OwnProps {
  theme?: string;
}

const DeliveryOptions: FC<OwnProps> = ({ theme }) => {
  const { t } = useTranslation();
  const deliveryOptions = useSelector(getDeliveryOptions);
  if (!deliveryOptions || !deliveryOptions.delivery || !deliveryOptions.delivery.length) {
    return null;
  }

  return (
    <div className={cn(styles.deliveryOptions, styles[`theme-${theme}`])}>
      <Accordion theme={theme} title={t('txt_delivery_information')} titleClassName={styles.title} expanded>
        <div className={styles.content}>
          <table>
            <thead>
              <tr>
                <th>{t('txt_dt_shipping_method')}</th>
                <th>{t('txt_dt_est_delivery_dates')}</th>
              </tr>
            </thead>
            <tbody>
              {deliveryOptions.delivery.map((option, i) => (
                <tr key={i}>
                  <td>{option.displayedName}</td>
                  <td align="center">
                    {option?.minDeliveryDay} - {option?.maxDeliveryDay}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <span className={styles.remark}>{t('txt_dt_ordered_time_cards')}</span>
        </div>
      </Accordion>
    </div>
  );
};

export default DeliveryOptions;
